import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

const FloatingChat = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(true);

  const whatsappNumber = '5493447542166';
  const whatsappMessage = encodeURIComponent(
    "Hi! I'm interested in information about Spanish classes at Hola Spanglish."
  );

  const smsNumber = '+5493447542166';
  const smsMessage = encodeURIComponent(
    "Hi! I'm interested in information about Spanish classes at Hola Spanglish."
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    const tooltipTimer = setTimeout(() => {
      setShowTooltip(false);
    }, 10000);

    return () => {
      clearTimeout(timer);
      clearTimeout(tooltipTimer);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-24 right-6 z-50 flex flex-col gap-4 items-end">
      {/* Tooltip */}
      {showTooltip && (
        <div className="bg-gradient-to-r from-pink-100 to-purple-100 text-purple-800 px-4 py-3 rounded-2xl shadow-2xl border-3 border-purple-300 max-w-xs animate-in slide-in-from-right duration-300 relative">
          <button
            onClick={() => setShowTooltip(false)}
            className="absolute -top-2 -right-2 w-6 h-6 bg-pink-400 text-white rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors duration-300 border-2 border-white"
          >
            <X className="h-3 w-3" />
          </button>
          <p className="text-sm font-bold mb-1">Need help?</p>
          <p className="text-xs text-purple-600">
            Message us on WhatsApp or iMessage! We reply fast 💬
          </p>
        </div>
      )}

      {/* iMessage Button */}
      <div className="group relative">
        <a
          href={`sms:+5493447542166${/iPhone|iPad|iPod/.test(navigator.userAgent) ? '&' : '?'}body=${smsMessage}`}
          className="w-14 h-14 bg-gradient-to-br from-blue-300 to-blue-400 hover:from-blue-400 hover:to-blue-500 text-white rounded-full shadow-xl flex items-center justify-center transition-all duration-300 hover:scale-110 animate-in zoom-in duration-300 border-3 border-blue-200"
          aria-label="Contact via iMessage"
          onClick={(e) => {
            console.log('iMessage link clicked');
          }}
        >
          <MessageCircle className="h-7 w-7" />
        </a>
        
        <div className="absolute right-16 top-1/2 -translate-y-1/2 bg-purple-600 text-white px-3 py-2 rounded-xl text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none border-2 border-purple-400">
          iMessage / SMS
          <div className="absolute right-[-6px] top-1/2 -translate-y-1/2 w-0 h-0 border-t-4 border-t-transparent border-b-4 border-b-transparent border-l-4 border-l-purple-600"></div>
        </div>
      </div>

      {/* WhatsApp Button */}
      <div className="group relative">
        <a
          href={`https://api.whatsapp.com/send?phone=5493447542166&text=${whatsappMessage}`}
          target="_blank"
          rel="noopener noreferrer"
          className="w-16 h-16 bg-gradient-to-br from-pink-300 to-pink-400 hover:from-pink-400 hover:to-pink-500 text-white rounded-full shadow-xl flex items-center justify-center transition-all duration-300 hover:scale-110 animate-in zoom-in duration-300 border-3 border-pink-200"
          aria-label="Contact via WhatsApp"
          onClick={(e) => {
            console.log('WhatsApp link clicked');
          }}
        >
          <svg
            viewBox="0 0 24 24"
            className="h-9 w-9 fill-current"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
          </svg>
        </a>

        <div className="absolute right-20 top-1/2 -translate-y-1/2 bg-purple-600 text-white px-3 py-2 rounded-xl text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none border-2 border-purple-400">
          WhatsApp
          <div className="absolute right-[-6px] top-1/2 -translate-y-1/2 w-0 h-0 border-t-4 border-t-transparent border-b-4 border-b-transparent border-l-4 border-l-purple-600"></div>
        </div>

        <div className="absolute inset-0 rounded-full bg-pink-400 animate-ping opacity-20 pointer-events-none"></div>
      </div>
    </div>
  );
};

export default FloatingChat;
